import React, { useState, useEffect, useRef } from 'react';
import { useSelector, connect } from 'react-redux';
import { array } from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import { bindActionCreators } from 'redux';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Button from 'yoda-core-components/lib/components/Button/Button';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import CMCouponApplyRemove from './CMCouponApplyRemove';
import CMCouponApplied from './CMCouponApplied';
import couponAction from '../../actions/CouponAction';
import adjustmentAction from '../../actions/AdjustmentAction';
import CMCouponDetails from './CMCouponDetails';
import CMCouponTierDetails from './CMCouponTierDetails';
import { getCouponExpirationDate, getLineCountMargin } from './pageUtils';
import CMCouponTargetLink from './CMCouponTargetLink';
import { getDeviceType } from '../../selectors/CMPageSelector';
import ShowBarCode from '../CMShowBarCode/ShowBarCode';
import CMMessages from './CMMessages';
import CMMessagePopup from './CMMessagePopup';
import CouponUtilsHelper from '../CouponList/CouponUtilsHelper';
import { toCapitalize } from '../../helpers/Utils/utils';
import { messageTypes, messageText, Config, COUPON_EXPIRED_ID } from './CMMessages.config';
import * as messagesActions from '../../actions/MessagesAction';
import { openModelEvent } from '../../actions/AnalyticsAction';

const CMCouponList = (props) => {
    const data = get(props, 'data', props);
    const deviceType = useSelector((state) => getDeviceType(state));
    const [showDetailsPanel, setShowDetailsPanel] = useState(false);
    const [contentItem, setContentItem] = useState({});
    let applyCouponStateOnLoad = true;
    const [showErrorPopUp, setErrorPopUp] = useState(false);
    const [showErrorInline, setErrorInline] = useState(false);
    const [currentAppliedCode, setCurrentAppliedCode] = useState('');
    const [isCouponApplyBtnClicked, setIsCouponApplyBtnClicked] = useState('');
    const divRefs = useRef([]);
    const [lineCounts, setLineCounts] = useState(0);

    const handleRefs = (ref) => {
        if (ref && !divRefs.current.includes(ref)) {
            divRefs.current.push(ref);
        }
    };

    useEffect(() => {
        props.actions.getAdjustments({
            drawerLoader: true,
        });
    }, []);
    const getCurrentAppliedCode = (code) => {
        setCurrentAppliedCode(code);
    };
    useEffect(() => {
        if (props?.couponPopupMessages?.length > 0 && isCouponApplyBtnClicked) {
            const errorCode = props?.couponPopupMessages[0]?.id;
            if (errorCode === COUPON_EXPIRED_ID) {
                setErrorPopUp(true);
            } else {
                setErrorInline(true);
            }
            props.actions.removeAllMessages({ section: Config.COUPON_POPUP_MESSAGES_ID });
        }
    }, [props?.couponPopupMessages, isCouponApplyBtnClicked]);
    const onClose = () => {
        setErrorPopUp(false);
    };

    useEffect(() => {
        const appliedCouponData = props.appliedAdjustments;
        if (applyCouponStateOnLoad && appliedCouponData && appliedCouponData.length > 0) {
            /* istanbul ignore next */
            if (appliedCouponData.length) {
                const appliedCouponDetails = filter(
                    appliedCouponData,
                    (couponData) => couponData.id && couponData.code === 'COUPON'
                );
                if (appliedCouponDetails[0] && !Cookies.load('COUPON_STATE')) {
                    CouponUtilsHelper.savePromoCode(appliedCouponDetails[0].value);
                }
                applyCouponStateOnLoad = false;
            }
        }
    }, [props.appliedAdjustments]);

    useEffect(() => {
        const calculateLineCounts = () => {
            const calculatedLineCounts = divRefs.current.map((divElement) => {
                const lineHeight = parseFloat(getComputedStyle(divElement).lineHeight);
                const divHeight = divElement.clientHeight;
                return Math.round(divHeight / lineHeight);
            });

            setLineCounts(calculatedLineCounts);
        };

        calculateLineCounts();
        window.addEventListener('resize', calculateLineCounts);

        return () => {
            window.removeEventListener('resize', calculateLineCounts);
        };
    }, []);

    const applyCoupon = props.appliedAdjustments && props.appliedAdjustments[0]?.value;
    const couponID = props.appliedAdjustments && props.appliedAdjustments[0]?.id;
    const getPromoValues = CouponUtilsHelper.getSavedPromoCodeValues();
    const ifCouponAlreadyApplied = getPromoValues && getPromoValues.length > 0 && getPromoValues[0];
    const couponItemsWithOffers = data?.contentItems.filter(
        (item) => item?.offers && !isEmpty(item?.offers)
    );

    const teaserTitleStyle = (item, linecount) => {
        const stylelis = [
            'mdOnly:w-5/12',
            'lg:w-4/12',
            'flex',
            'flex-col',
            'justify-center',
            'items-center',
            'smOnly:px-6',
            'smOnly:py-6',
            'md:border-l',
            'smOnly:border-t',
            'border-dashed',
            'border-gray-25',
            item.teaserTitle ? 'smOnly:-mx-6' : '',
            'sm:text-center',
            item.teaserTitle ? 'lg:pl-12' : 'md:pl-2',
            item.teaserTitle ? 'mdOnly:pl-6' : '',
            item.teaserTitle ? 'md:-mt-[6px]' : '',
        ];
        // eslint-disable-next-line prefer-spread
        stylelis.push.apply(stylelis, getLineCountMargin(linecount));
        return stylelis;
    };

    return (
        <>
            <div className={dt(['flex', 'flex-col', 'items-center'])}>
                <p className={dt(['text-xlarge', 'font-bold'])} data-automation-id="at-list-title">
                    {data?.teaserTitle}
                </p>
            </div>
            {couponItemsWithOffers &&
                couponItemsWithOffers.map((item, index) => {
                    if (isEmpty(item.offers)) return null;
                    return (
                        <div
                            id="couponTileContainer"
                            className={dt([
                                item.teaserTitle ? 'mt-[14px]' : 'mt-6',
                                index === couponItemsWithOffers.length - 1 && 'my-0',
                            ])}
                        >
                            <fieldset
                                className={dt([
                                    'border',
                                    'border-solid',
                                    'md:rounded-md',
                                    'smOnly:rounded',
                                    'smOnly:shadow-[0_2px_4px_0_rgba(32,32,32,0.25)]',
                                    item.promoCode === applyCoupon
                                        ? 'border-[#01803f]'
                                        : 'border-gray-25',
                                    showErrorInline && item.promoCode === currentAppliedCode
                                        ? 'border-[#A32026]'
                                        : 'border-gray-25',
                                    item.teaserTitle ? 'px-6' : '',
                                    item.teaserTitle ? 'pt-[10px]' : '',
                                ])}
                            >
                                <legend
                                    className={dt([
                                        item.teaserTitle ? 'px-4' : '',
                                        item.teaserTitle ? 'mdOnly:px-2' : '',
                                        item.teaserTitle ? 'lg:max-w-[55%]' : '',
                                        item.teaserTitle ? 'mdOnly:max-w-[55%]' : '',
                                        'lg:text-2xlarge',
                                        'mdOnly:text-base',
                                        'smOnly:text-[20px]',
                                        'smOnly:leading-8',
                                        'font-semibold',
                                        'bg-white',
                                        'smOnly:text-center',
                                    ])}
                                    key={item}
                                    ref={handleRefs}
                                >
                                    <p data-automation-id="at-teaser-title">
                                        {toCapitalize(item.teaserTitle)}
                                    </p>
                                </legend>
                                <div
                                    className={dt([
                                        'flex',
                                        'smOnly:flex-col',
                                        item.teaserTitle ? '-mt-4' : '',
                                    ])}
                                >
                                    <div
                                        className={dt([
                                            'mdOnly:w-7/12',
                                            'lg:w-8/12',
                                            'lg:pr-6',
                                            'mdOnly:pr-6',
                                            item.teaserTitle ? '' : 'lg:-ml-2',
                                            item.teaserTitle ? '' : 'mdOnly:-ml-1',
                                            'md:flex',
                                            'md:flex-col',
                                            'md:justify-center',
                                        ])}
                                    >
                                        <div
                                            className={dt([
                                                item.teaserTitle ? 'lg:pl-4' : 'lg:pl-12',
                                                item.teaserTitle ? '' : 'md:pl-7',
                                                'lg:pr-10',
                                                item?.validTo ? 'md:pb-4' : 'md:pb-6',
                                                item.teaserTitle ? 'py-6' : 'p-6',
                                            ])}
                                        >
                                            {deviceType.isMobile ? (
                                                <p
                                                    className={dt([
                                                        'smOnly:text-small',
                                                        'smOnly:font-normal',
                                                        'smOnly:text-center',
                                                    ])}
                                                    data-automation-id="at-teaser-title-mobile"
                                                >
                                                    {data?.teaserTitle}
                                                </p>
                                            ) : null}
                                            <CMCouponTierDetails item={item} />
                                        </div>
                                        <div
                                            className={dt([
                                                'text-sm',
                                                'mdOnly:text-xsmall',
                                                'font-normal',
                                                'leading-5',
                                                item.teaserTitle ? 'lg:px-4' : 'lg:px-12',
                                                item.validTo
                                                    ? 'smOnly:justify-between'
                                                    : 'smOnly:justify-center',
                                                'pb-6',
                                                'flex',
                                                !item.teaserTitle ? 'mdOnly:pl-7' : '',
                                                !item.teaserTitle ? 'smOnly:pl-6' : '',
                                                !item.teaserTitle ? 'smOnly:pr-6' : '',
                                            ])}
                                        >
                                            {item?.validTo ? (
                                                <span
                                                    data-automation-id="at-coupon-expiry"
                                                    className={dt(['mdOnly:text-xsmall'])}
                                                >
                                                    Expires {getCouponExpirationDate(item?.validTo)}
                                                </span>
                                            ) : null}
                                            <Button
                                                buttonId="couponDetailsBtn"
                                                onClick={() => {
                                                    setShowDetailsPanel(true);
                                                    setContentItem(item);
                                                    props.actions.openModelEvent({
                                                        name: 'opened coupon detail',
                                                    });
                                                }}
                                                size="Sm"
                                                buttonType="Link"
                                            >
                                                <span
                                                    className={dt([
                                                        'pl-1',
                                                        'font-normal',
                                                        'mdOnly:text-xsmall',
                                                    ])}
                                                    data-automation-id="at-coupon-details-btn"
                                                >
                                                    Details
                                                </span>
                                            </Button>
                                        </div>
                                    </div>
                                    <div
                                        className={dt(teaserTitleStyle(item, lineCounts[index]))}
                                        data-automation-id="at-teaser-applyremove-container"
                                    >
                                        <div
                                            className={dt([
                                                item.teaserTitle ? 'lg:pl-4' : 'lg:pl-10',
                                                item.teaserTitle ? '' : 'md:pl-7',
                                                item.teaserTitle ? '' : 'md:pr-7',
                                                'lg:pr-10',
                                                'md:pt-6',
                                                'md:pb-6',
                                                'smOnly:w-full',
                                            ])}
                                        >
                                            {item?.redeemingChannel !== 'instore' && (
                                                <div
                                                    className={dt([
                                                        item.promoCode === applyCoupon
                                                            ? 'pb-4'
                                                            : '',
                                                    ])}
                                                >
                                                    <CMCouponApplied
                                                        appliedAdjustments={
                                                            props.appliedAdjustments
                                                        }
                                                        bagItems={props.bagItems}
                                                        ifCouponAlreadyApplied={
                                                            !isEmpty(ifCouponAlreadyApplied)
                                                        }
                                                        item={item}
                                                        redeemingChannel={item?.redeemingChannel}
                                                    />
                                                </div>
                                            )}
                                            {showErrorInline &&
                                                item.promoCode === currentAppliedCode && (
                                                    <CMMessages
                                                        type={messageTypes.error}
                                                        title={messageText.error?.title}
                                                        subTitle={messageText.error?.subTitle}
                                                    />
                                                )}
                                            <div
                                                className={dt([
                                                    item.promoCode === applyCoupon ? 'flex' : '',
                                                    item.promoCode === applyCoupon
                                                        ? 'flex-col'
                                                        : '',
                                                    item.promoCode === applyCoupon
                                                        ? 'items-center'
                                                        : '',
                                                ])}
                                            >
                                                <CMCouponApplyRemove
                                                    couponData={item}
                                                    couponID={couponID}
                                                    isAdjustmentApplied={
                                                        item.promoCode === applyCoupon
                                                    }
                                                    getCurrentAppliedCode={getCurrentAppliedCode}
                                                    setApplyBtnClicked={(value) => {
                                                        setIsCouponApplyBtnClicked(value);
                                                        setErrorInline(false);
                                                    }}
                                                />
                                                {deviceType.isMobile ? (
                                                    <div>
                                                        <ShowBarCode item={item} />
                                                    </div>
                                                ) : null}
                                                {item.linkText ? (
                                                    <div>
                                                        <CMCouponTargetLink contentItem={item} />
                                                    </div>
                                                ) : null}
                                                {!deviceType.isMobile ? (
                                                    <div>
                                                        <ShowBarCode item={item} />
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    );
                })}
            <>
                {showErrorPopUp && (
                    <CMMessagePopup
                        type={messageTypes.error}
                        title={messageText.errorText?.title}
                        onClose={() => onClose()}
                        showErrorPopUp={showErrorPopUp}
                        iconComponent=""
                    />
                )}
            </>
            <CMCouponDetails
                setShowDetailsPanel={setShowDetailsPanel}
                showDetailsPanel={showDetailsPanel}
                contentItem={contentItem}
            />
        </>
    );
};

const mapStateToProps = (state) => ({
    appliedAdjustments: state.appliedAdjustments || [],
    bagItems: state.bagItems || [],
    couponPopupMessages: state.messages && state.messages[Config.COUPON_POPUP_MESSAGES_ID],
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        { ...adjustmentAction, ...couponAction, ...messagesActions, openModelEvent },
        dispatch
    ),
});

CMCouponList.propTypes = {
    appliedAdjustments: array,
    bagItems: array,
    couponPopupMessages: array,
};

CMCouponList.defaultProps = {
    appliedAdjustments: [],
    bagItems: [],
    couponPopupMessages: [],
};

export default connect(mapStateToProps, mapDispatchToProps)(CMCouponList);
